<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";

// Custom Components
import PageHeader from "@/components/page-header";
import DeviceDrawer from "@/components/superAdmin/IOTLock/Device.vue";
import appConfig from "@/app.config";
import errorHandler from "@/helpers/errorHandler";
import UserService from "@/helpers/APIService/user.service";
import Middlewares from "@/helpers/middlewares";
import superService from "@/helpers/APIService/super.service";

export default {
  page: {
    title: "device",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of IOT Device",
      isLoading: false,
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      tableDataCopy: [],
      addDeviceModel: false,
      isEdit: false,
      deviceId: null,
      device: null,
      filters: {
        hotel: { text: "All", value: "all" },
        iot_device_model: { text: "All", value: "all" },
        iot_gateway: { text: "All", value: "all" },
        status: "all",
      },
      isBulkBtnLoading: false,
      image: null,
      hotels: [],
      deviceModels: [{ text: "All", value: "all" }],
      gateways: [{ text: "All", value: "all" }],
      csvUploadResponse: {
        success: [],
        failed: [],
      },
      isChangeFilterValue: false,
      isApplyFilter: false,
    };
  },
  computed: {
    deviceProps() {
      return {
        deviceId: this.deviceId,
        isEdit: this.isEdit,
        device: this.device,
      };
    },
  },
  components: {
    PageHeader,
    Drawer,
    DeviceDrawer,
    MultiSelect,
  },
  mounted() {
    this.getDevices(`?size=${this.table.size}`);
    this.getOptions();
  },
  methods: {
    // Method is used to get list of all hotels
    async getOptions() {
      //  Get hotel options
      if (localStorage.hotels) {
        this.hotels = JSON.parse(atob(localStorage.getItem("hotels")));
      } else {
        this.hotels = Middlewares.hotelList();
      }
      // Get Device model option
      if (localStorage.device_model) {
        this.deviceModels = JSON.parse(
          atob(localStorage.getItem("device_model"))
        );
      } else {
        const response = await UserService.getDeviecModelList();
        if (response) {
          response.map((model) => {
            this.deviceModels.push({ text: model.name, value: model.id });
          });
        }
      }
      // get gateway options
      const response = await superService.getGatewayList();
      if (response) {
        response.results.map((gateway) => {
          this.gateways.push({ text: gateway.name, value: gateway.id });
        });
      }
    },
    // Method is used to get device list
    async getDevices(query) {
      this.isLoading = true;
      try {
        const response = await UserService.getDevieceList(query);
        if (response) {
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.tableData = response.results;
          this.tableDataCopy = response.results;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle drawer
    addDeviceDrawer(isEdit) {
      if (typeof isEdit !== "boolean") {
        this.isEdit = false;
        this.deviceId = null;
        this.device = null;
      }
      this.addDeviceModel = !this.addDeviceModel;
    },
    // Method is used to add device in bulk
    bulkDeviceAdd() {
      this.$bvModal.show("bulk-device-add-modal");
    },
    // Method is use update and add new guest in guest list table
    handleSubmit({ data, isEdit }) {
      if (isEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.table.tableData.push(data);
      }
      this.isEdit = false;
      this.deviceId = null;
      this.device = null;
      this.addDeviceDrawer();
      Middlewares.notification(
        `${isEdit ? "Updated successfully !!" : "Added successfully !!"}`,
        "success"
      );
    },
    // Method is used to update device in bulk
    handleBulkSubmit() {
      this.isBulkBtnLoading = true;
      const data = new FormData();
      data.append("device_csv", this.image);
      UserService.bulkDeviceAdd(data)
        .then((response) => {
          this.$bvModal.show("bulk-device-add-response-modal");
          this.csvUploadResponse.success = response.success;
          this.csvUploadResponse.failed = response.failed;
          this.getDevices(`?size=${this.table.size}`);
          Middlewares.notification("File successfully uploaded !!", "success");
          this.isBulkBtnLoading = false;
          this.$bvModal.hide("bulk-device-add-modal");
        })
        .catch((error) => {
          this.isBulkBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is used to edit device
    editDevice(device) {
      this.isEdit = true;
      this.device = device;
      this.deviceId = device.id;
      this.addDeviceDrawer(this.isEdit);
    },
    // Method is used to change status
    changeStatus(device) {
      let deviceData = new FormData();
      deviceData.append("is_active", device.is_active);
      UserService.editDevieceData(device.id, deviceData)
        .then(() => {
          Middlewares.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete device
    deleteDevice(device_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteDevice(device_id)
            .then(() => {
              this.table.tableData = this.table.tableData.filter(
                (device) => device.id !== device_id
              );
              Middlewares.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getDevices(`?${str[1]}`);
      }
    },
    // Method is used to handle bulk upload image
    changeImage(event) {
      if (event.target.files[0] !== undefined) {
        this.image = event.target.files[0];
      }
    },
    // Method is used to handle filter
    handleFilter() {
      this.isChangeFilterValue = true;
    },
    // Method is used to handle filter
    applyFilter() {
      if (this.isApplyFilter) {
        this.filters = {
          hotel: { text: "All", value: "all" },
          iot_device_model: { text: "All", value: "all" },
          iot_gateway: { text: "All", value: "all" },
          status: "all",
        };
        this.isApplyFilter = false;
        return this.getDevices(`?size=${this.table.size}`);
      }
      if (this.isChangeFilterValue) {
        this.isApplyFilter = true;
        let filter = "";
        if (this.filters.hotel.value !== "all") {
          filter += `${filter == "" ? "?" : "&"}hotel=${
            this.filters.hotel.value
          }`;
        }
        if (this.filters.iot_device_model.value !== "all") {
          filter += `${filter == "" ? "?" : "&"}iot_device_model=${
            this.filters.iot_device_model.value
          }`;
        }
        if (this.filters.status !== "all") {
          filter += `${filter == "" ? "?" : "&"}is_active=${
            this.filters.status
          }`;
        }
        if (this.filters.iot_gateway.value !== "all") {
          filter += `${filter == "" ? "?" : "&"}iot_gateway=${
            this.filters.iot_gateway.value
          }`;
        }
        this.getDevices(filter);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :dropDownItem="[
        { name: 'Add New', action: addDeviceDrawer },
        { name: 'Bulk Device', action: bulkDeviceAdd },
      ]"
      :dropDown="'Add New'"
      :isButtonDropDown="true"
    />
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="100"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <!-- Filter device by hotel -->
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8">
              <MultiSelect
                class="mb-2"
                v-model="filters.hotel"
                :options="hotels"
                :show-labels="false"
                placeholder="Select Hotel"
                track-by="value"
                label="text"
                name="hotels"
                @close="handleFilter()"
              />
            </div>
            <!-- Filter device by hotel -->
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4">
              <MultiSelect
                class="mb-2"
                v-model="filters.iot_device_model"
                :options="deviceModels"
                :show-labels="false"
                placeholder="Select iot device model"
                track-by="value"
                label="text"
                name="iot_device_model"
                @close="handleFilter()"
              />
            </div>
            <!-- Filter device by gateway -->
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4">
              <MultiSelect
                class="mb-2"
                v-model="filters.iot_gateway"
                :options="gateways"
                :show-labels="false"
                placeholder="Select gateway"
                track-by="value"
                label="text"
                name="iot_gateway"
                @close="handleFilter()"
              />
            </div>
            <!-- Filter device by status -->
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4">
              <select
                name="is_active"
                id="is_active"
                class="form-control mb-2"
                v-model="filters.status"
                placeholder="by is active"
                @change="handleFilter()"
              >
                <option value="all">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <!-- Appyl Filter -->
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4">
              <b-button
                variant="primary"
                class="float-end float-sm-start mb-2"
                @click="applyFilter"
                >{{
                  !isApplyFilter ? "Apply Filter" : "Clear Filter"
                }}</b-button
              >
            </div>
          </div>
          <div class="table-responsive">
            <v-table
              :data="table.tableData"
              class="table table-hover mb-0"
              ref="my-table"
            >
              <thead class="table-light" slot="head">
                <tr>
                  <v-th sortKey="iot_device_model.name">Device Model</v-th>
                  <v-th sortKey="iot_gateway.name">Device Gateway</v-th>
                  <v-th sortKey="device_name">Device name</v-th>
                  <v-th sortKey="iot_device_model.device_type"
                    >Device Type</v-th
                  >
                  <th>Hotel</th>
                  <th>Update by</th>
                  <th>Timestamp</th>
                  <th>Remark</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                slot="body"
                slot-scope="{ displayData }"
                v-if="!isLoading && table.tableData.length !== 0"
              >
                <tr v-for="(device, index) in displayData" :key="index">
                  <td @click="editDevice(device)">
                    {{
                      device.iot_device_model !== null
                        ? device.iot_device_model.name
                        : "-"
                    }}
                  </td>
                  <td @click="editDevice(device)">
                    {{
                      device.iot_gateway !== null
                        ? device.iot_gateway.name
                        : "-"
                    }}
                  </td>
                  <td @click="editDevice(device)">
                    {{ device.device_name !== null ? device.device_name : "-" }}
                  </td>
                  <td @click="editDevice(device)">
                    {{
                      device.iot_device_model !== null
                        ? device.iot_device_model.device_type.replaceAll(
                            "_",
                            " "
                          )
                        : "-"
                    }}
                  </td>
                  <td @click="editDevice(device)">
                    {{
                      device.iot_gateway !== null
                        ? device.iot_gateway.hotel !== null
                          ? device.iot_gateway.hotel.name
                          : "-"
                        : "-"
                    }}
                  </td>
                  <td @click="editDevice(device)">
                    {{ device.updated_by !== null ? device.updated_by : "-" }}
                  </td>
                  <td @click="editDevice(device)">
                    {{
                      global_format_date_and_time_custom(
                        device.created_at,
                        "YYYY-MM-DD hh:mm A"
                      )
                    }}
                  </td>
                  <td @click="editDevice(device)">
                    <div class="overflow-tip">
                      <span>
                        {{ device.remark !== null ? device.remark : "-" }}</span
                      >
                    </div>
                  </td>
                  <td>
                    <div class="form-check form-switch my-1" slot="is_active">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="device.is_active"
                        @change="
                          changeStatus({
                            id: device.id,
                            is_active: device.is_active,
                          })
                        "
                      />
                    </div>
                  </td>
                  <td>
                    <i
                      class="fas fa-pencil-alt text-success mx-1"
                      v-b-popover.hover="'Edit recored'"
                      id="edit"
                      @click="editDevice(device)"
                    ></i>
                    <i
                      class="mdi mdi-trash-can text-danger fs-5 mx-1"
                      v-b-popover.hover="'View card details'"
                      @click="deleteDevice(device.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else-if="isLoading">
                <tr v-for="item in 20" :key="item">
                  <td class="placeholder-glow" v-for="no in 10" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else>
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
      </div>
    </div>
    <!--Add and update device drawer -->
    <Drawer
      @close="addDeviceDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="addDeviceModel">
        <DeviceDrawer
          :currentProps="deviceProps"
          @submitted="handleSubmit"
          @cancelSubmit="addDeviceDrawer()"
        ></DeviceDrawer>
      </div>
    </Drawer>
    <!-- Add device into bulk using csv drawer -->
    <b-modal
      id="bulk-device-add-modal"
      title="Add Device In Bulk"
      title-class="font-18"
      centered
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleBulkSubmit">
        <b-form-group label="file" label-for="file-input" class="mb-3">
          <p slot="label">Excel File</p>
          <b-form-file
            id="file-input"
            type="file"
            plain
            class="form-control"
            accept=".csv, .xml, .xmlx"
            @change="changeImage($event)"
          ></b-form-file>
        </b-form-group>
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          @click="handleBulkSubmit"
          :class="{ disabled: isBulkBtnLoading }"
        >
          <i
            v-if="isBulkBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Save
        </b-button>
      </form>
    </b-modal>

    <!-- Bulk device added response -->
    <b-modal
      id="bulk-device-add-response-modal"
      title="Add Device In Bulk Status"
      title-class="font-18"
      size="xl"
      centered
      hide-footer
    >
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-2 text-muted"
      >
        <b-tab active>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Success</span>
          </template>
          <div class="table-responsive fixTableHead">
            <table class="table table-hover mb-0" ref="my-success">
              <thead class="table-light" slot="head">
                <tr>
                  <th>Device Address</th>
                  <th>Gateway</th>
                  <th>Name</th>
                  <th>Remarks</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                v-if="csvUploadResponse.success.length !== 0"
              >
                <tr
                  v-for="(item, index) in csvUploadResponse.success"
                  :key="index"
                >
                  <td>
                    {{
                      item.device.address !== null ? item.device.address : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.device.gateway !== null ? item.device.gateway : "-"
                    }}
                  </td>
                  <td>
                    {{ item.device.name !== null ? item.device.name : "-" }}
                  </td>
                  <td>
                    {{
                      item.device.remarks !== null ? item.device.remarks : "-"
                    }}
                  </td>
                  <td>
                    {{ item.device.type !== null ? item.device.type : "-" }}
                  </td>
                  <td>
                    <span
                      class="badge align-items-center py-1 px-2 card-badge"
                      :class="[
                        item.message === 'updated'
                          ? 'badge-soft-info'
                          : item.message === 'created'
                          ? 'badge-soft-success'
                          : 'badge-soft-secondary',
                      ]"
                    >
                      {{ item.message }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else>
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">Failed</span>
          </template>
          <div class="table-responsive fixTableHead">
            <table class="table table-hover mb-0" ref="my-failed">
              <thead class="table-light" slot="head">
                <tr>
                  <th>Device Address</th>
                  <th>Gateway</th>
                  <th>Name</th>
                  <th>Remarks</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                v-if="csvUploadResponse.failed.length !== 0"
              >
                <tr
                  v-for="(item, index) in csvUploadResponse.failed"
                  :key="index"
                >
                  <td>
                    {{
                      item.device.address !== null ? item.device.address : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.device.gateway !== null ? item.device.gateway : "-"
                    }}
                  </td>
                  <td>
                    {{ item.device.name !== null ? item.device.name : "-" }}
                  </td>
                  <td>
                    {{
                      item.device.remarks !== null ? item.device.remarks : "-"
                    }}
                  </td>
                  <td>
                    {{ item.device.type !== null ? item.device.type : "-" }}
                  </td>
                  <td>
                    <span
                      class="badge align-items-center py-1 px-2 card-badge badge-soft-danger"
                    >
                      {{ item.message }}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else>
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>
